import { render, staticRenderFns } from "./VideoRunsTable.vue?vue&type=template&id=516c16d1&scoped=true"
import script from "./VideoRunsTable.vue?vue&type=script&lang=js"
export * from "./VideoRunsTable.vue?vue&type=script&lang=js"
import style0 from "./VideoRunsTable.vue?vue&type=style&index=0&id=516c16d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516c16d1",
  null
  
)

export default component.exports